import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialized: false,
  initializing: false
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    initializeApp: (state) => {
      state.initializing = true;
    },
    setAppInitialized: (state) => {
      state.initialized = true;
      state.initializing = false;
    }
  },
});

export const { initializeApp, setAppInitialized } = appSlice.actions;
export default appSlice.reducer;
